import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class PlasticCabinet extends DestroyableObstacle {
	static key = "PlasticCabinet";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.PLASTIC_DEBRIS;
	}

	static deserialize(data: any): PlasticCabinet {
		const c = new PlasticCabinet(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
